import { SVGInterface } from "../../interface";

const Trash = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2222 4C10.02 4 9.82347 4.08123 9.67663 4.22991C9.52937 4.37901 9.44444 4.58385 9.44444 4.8V5.6H14.5556V4.8C14.5556 4.58385 14.4706 4.37901 14.3234 4.22991C14.1765 4.08123 13.98 4 13.7778 4H10.2222ZM16.5556 5.6V4.8C16.5556 4.06137 16.2659 3.35054 15.7463 2.82451C15.2264 2.29806 14.5185 2 13.7778 2H10.2222C9.48147 2 8.77361 2.29806 8.25366 2.82451C7.73412 3.35054 7.44444 4.06137 7.44444 4.8V5.6H3V7.6H4.77778V19.2C4.77778 19.9386 5.06746 20.6495 5.58699 21.1755C6.10694 21.7019 6.81481 22 7.55556 22H16.4444C17.1852 22 17.8931 21.7019 18.413 21.1755C18.9325 20.6495 19.2222 19.9386 19.2222 19.2V7.6H21V5.6H16.5556ZM6.77778 7.6V19.2C6.77778 19.4162 6.8627 19.621 7.00996 19.7701C7.15681 19.9188 7.35331 20 7.55556 20H16.4444C16.6467 20 16.8432 19.9188 16.99 19.7701C17.1373 19.621 17.2222 19.4162 17.2222 19.2V7.6H6.77778ZM11.2222 10.1V17.5H9.22222V10.1H11.2222ZM14.7778 10.1V17.5H12.7778V10.1H14.7778Z"
      fill={color || "#0E171F"}
    />
  </svg>
);
export default Trash;
